var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import _ from 'lodash';
import { observable } from 'mobx';
import Request from './Request';
import Signals from '../signals/Signals';
/**
 *
 */
var RequestController = /** @class */ (function () {
    function RequestController() {
        this.activeRequests = [];
    }
    /**
     * Creates a Request object
     *
     * @param method String The Method
     * @param endpoint String The dndpoint url
     * @param parameters Object The endpoint url parameters
     * @param data Object The request data
     *
     * @return {Request}
     */
    RequestController.prototype.createRequest = function (method, endpoint, parameters, data) {
        if (parameters === void 0) { parameters = {}; }
        if (data === void 0) { data = {}; }
        var url = endpoint;
        // Replace Endpoint dynamic parameters like `:companyId` with values if found
        // in `parameters`, like `{companyId: 4}`
        for (var parameter in parameters) {
            if (parameters.hasOwnProperty(parameter)) {
                url = url.replace(':' + parameter, parameters[parameter]);
            }
        }
        return new Request({ method: method, url: url, data: data });
    };
    /**
     *
     * @param request
     */
    RequestController.prototype.addRequest = function (request) {
        this.activeRequests = this.activeRequests.concat([request]);
        this.updateRequests();
    };
    /**
     *
     * @param request
     */
    RequestController.prototype.removeRequest = function (request) {
        _.remove(this.activeRequests, function (item) {
            return request === item;
        });
        // Force trigger mobx event
        this.activeRequests = this.activeRequests.concat([]);
        this.updateRequests();
    };
    RequestController.prototype.updateRequests = function () {
        if (this.activeRequests.length > 0) {
            Signals.ShowLoadingScreen.dispatch();
        }
        else {
            Signals.HideLoadingScreen.dispatch();
        }
    };
    Object.defineProperty(RequestController.prototype, "hasBlockingRequests", {
        /**
         *
         * @return {boolean}
         */
        get: function () {
            return this.activeRequests.filter(function (request) {
                return !!request.blockUI;
            }).length > 0;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        observable
    ], RequestController.prototype, "activeRequests", void 0);
    return RequestController;
}());
var requestController = new RequestController();
export default requestController;
